module.exports = "/_next/static/images/16949585372352955223778b7cd50c77-pregnant-woman@tablet@3x.jpg.webp";